import { render, staticRenderFns } from "./baseSelectPerson.vue?vue&type=template&id=fd8fa0ba&scoped=true&"
import script from "./baseSelectPerson.vue?vue&type=script&lang=ts&"
export * from "./baseSelectPerson.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8fa0ba",
  null
  
)

export default component.exports